function teamsService($http) {
  const service = {};

  service.getChannelList = async (integrationId) => {
    const { data } = await $http.get(
      `/websked/api/company/integrations/teams/${integrationId}/channels`
    );
    return data;
  };

  service.getUserList = async (integrationId) => {
    const { data } = await $http.get(
      `/websked/api/company/integrations/teams/${integrationId}/users`
    );
    return data;
  };

  return service;
}

const serviceArray = ['$http', teamsService];

module.exports = (ngModule) => {
  ngModule.factory('teamsService', serviceArray);
};
